import React, {
  Fragment,
  useContext,
  useEffect,
  useState,
  useRef,
} from "react";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import TextField from "@mui/material/TextField";
import FormControlLabel from "@mui/material/FormControlLabel";
import Autocomplete from "@mui/material/Autocomplete";
import { AlertContext } from "../../../context/AlertContext";
import { ConfiguracionContext } from "../../../context/ConfiguracionContext";
import { ServiciosContext } from "../../../context/ServiciosContext";
import Fab from "@mui/material/Fab";
import AddIcon from "@mui/icons-material/Add";
import EditIcon from "@mui/icons-material/Edit";
import { Link, Redirect } from "react-router-dom";
import Spinner from "../Spinner";
import { AuthContext } from "../../../context/AuthContext";
import { Checkbox } from "primereact/checkbox";
import { Button } from "primereact/button";
import { Tooltip } from "primereact/tooltip";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import "../../../assets/css/DataTableDemo.css";
import "primereact/resources/themes/saga-blue/theme.css";
import "primereact/resources/primereact.min.css";
import "primeicons/primeicons.css";
import "../../../assets/css/PrimeGrid.css";
import "../../../assets/css/CierreDialog.css";
import { Tag } from "primereact/tag";
import { InputText } from "primereact/inputtext";
import ButtonMui from "@mui/material/Button";
import CheckIcon from "@mui/icons-material/Check";
import CloseIcon from "@mui/icons-material/Close";
import { Toast } from "primereact/toast";
import { Dialog } from "primereact/dialog";
import { ConfirmDialog, confirmDialog } from "primereact/confirmdialog";
import hcOffcanvasNav from "hc-offcanvas-nav";
import $ from "jquery";
import { saveAs } from "file-saver";
import { Navigate, useNavigate } from "react-router-dom";
import Barra from "../Barra";
import { ThemeProvider } from "@mui/material/styles";
import Box from "@mui/material/Box";
import Paper from "@mui/material/Paper";
import PaymentsOutlinedIcon from "@mui/icons-material/PaymentsOutlined";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import { getBrand, createBrandTheme } from "../../../theme/brand";
import PantallaHeader from "../common/PantallaHeader";
import { InputMask } from "primereact/inputmask";
import { InputNumber } from "primereact/inputnumber";

const colores = [
  {
    id: 3,
    nombre: "AMARILLO",
  },
  {
    id: 4,
    nombre: "VERDE",
  },
  {
    id: 5,
    nombre: "ROJO",
  },
  {
    id: 6,
    nombre: "AZUL",
  },
];

const localidades = [
  {
    id: 1,
    nombre: "CIUDAD",
  },
  {
    id: 2,
    nombre: "OTROS",
  },
];

export default function ValorizacionesServiciosMoviles(props) {
  const [valorizacion, guardarValorizacion] = useState(null);
  const [visible, setVisible] = useState(false);
  const [globalFilter, setGlobalFilter] = useState(null);
  let navigate = useNavigate();
  const toast = useRef(null);
  const [selectedRow, setSelectedRow] = useState(null);
  const acTipoMovil = useRef(null);
  const acLocalidad = useRef(null);

  //Context

  const alertContext = useContext(AlertContext);
  const { mensajeAlerta } = alertContext;

  const authContext = useContext(AuthContext);
  const { state, usuarioAutenticado } = authContext;

  const configuracionContext = useContext(ConfiguracionContext);
  const {
    statusAcceso,
    configuracion,
    valorizaciones,
    tiposMoviles,
    obtenerValorizacionesMoviles,
    obtenerAcceso,
    actualizarValorizacionesMoviles,
    agregarValorizacionesMoviles,
    eliminarValorizacionesMoviles,
    obtenerTiposMoviles,
  } = configuracionContext;

  const theme = createBrandTheme(getBrand(configuracion));

  useEffect(() => {
    if (state.usuario) {
      obtenerAcceso({
        usuarioId: state.usuario.id,
        layout: "ValorizacionesServicios",
      });
    }
  }, [state.id]);

  useEffect(() => {
    obtenerValorizacionesMoviles();
    obtenerTiposMoviles();
  }, []);

  setTimeout(() => {
    if (statusAcceso === 400) {
      accesoDenegado();
    }
  }, 3000);

  const exitClick = (e) => {
    navigate(`/`);
  };

  const addClick = (e) => {
    //navigate(`/base/0`);
    setVisible(true);
    setSelectedRow(null);
    guardarValorizacion(null);
  };

  const aceptarClick = (e) => {
    e.preventDefault();
    //Validar
    if (
      !valorizacion ||
      valorizacion.color === undefined ||
      valorizacion.color === null ||
      valorizacion.color.trim() === ""
    ) {
      mensajeAlerta(
        "Valorización de Móviles",
        "El color es necesario !.",
        "error",
      );
      return;
    }

    if (
      valorizacion &&
      valorizacion.color === "AZUL" &&
      (!valorizacion.id_tipomovil ||
        valorizacion.id_tipomovil === null ||
        valorizacion.id_tipomovil === "")
    ) {
      mensajeAlerta(
        "Valorización de Móviles",
        "El tipo de móvil es necesario !.",
        "error",
      );
      return;
    }

    if (
      !valorizacion ||
      valorizacion.localidad === undefined ||
      valorizacion.localidad === null ||
      valorizacion.localidad.trim() === ""
    ) {
      mensajeAlerta(
        "Valorización de Móviles",
        "La localidad es necesaria !.",
        "error",
      );
      return;
    }

    if (
      !valorizacion ||
      valorizacion.km1 === undefined ||
      valorizacion.km1 === null ||
      valorizacion.km1 === "" ||
      valorizacion.km1 === "0" ||
      Number(valorizacion.km1) <= 0
    ) {
      mensajeAlerta(
        "Valorización de Móviles",
        "Hasta KM 1 es necesario !.",
        "error",
      );
      return;
    }

    if (
      !valorizacion ||
      valorizacion.valor1 === undefined ||
      valorizacion.valor1 === null ||
      valorizacion.valor1 === "" ||
      valorizacion.valor1 === "0" ||
      Number(valorizacion.valor1) <= 0
    ) {
      mensajeAlerta(
        "Valorización de Móviles",
        "Valor 1 es necesario !.",
        "error",
      );
      return;
    }

    if (
      valorizacion &&
      valorizacion.km2 &&
      Number(valorizacion.km2 > 0) &&
      Number(valorizacion.km2 <= valorizacion.km1)
    ) {
      mensajeAlerta(
        "Valorización de Móviles",
        "Km 2 debe ser mayor que km 1 !.",
        "error",
      );
      return;
    }

    if (
      valorizacion &&
      valorizacion.km2 &&
      Number(valorizacion.km2 > 0) &&
      (!valorizacion.valor2 ||
        valorizacion.valor2 === null ||
        Number(valorizacion.valor2) <= 0)
    ) {
      mensajeAlerta(
        "Valorización de Móviles",
        "Valor 2 es necesario !.",
        "error",
      );
      return;
    }

    if (
      valorizacion &&
      valorizacion.valor2 &&
      Number(valorizacion.valor2 > 0) &&
      (!valorizacion.km2 ||
        valorizacion.km2 === null ||
        Number(valorizacion.km2) <= 0)
    ) {
      mensajeAlerta(
        "Valorización de Móviles",
        "Hasta Km 2 es necesario !.",
        "error",
      );
      return;
    }

    if (
      valorizacion &&
      valorizacion.km3 &&
      Number(valorizacion.km3 > 0) &&
      Number(valorizacion.km3 <= valorizacion.km2)
    ) {
      mensajeAlerta(
        "Valorización de Móviles",
        "Km 3 debe ser mayor que km 2 !.",
        "error",
      );
      return;
    }

    if (
      valorizacion &&
      valorizacion.km3 &&
      Number(valorizacion.km3 > 0) &&
      (!valorizacion.valor3 ||
        valorizacion.valor3 === null ||
        Number(valorizacion.valor3) <= 0)
    ) {
      mensajeAlerta(
        "Valorización de Móviles",
        "Valor 3 es necesario !.",
        "error",
      );
      return;
    }

    if (
      valorizacion &&
      valorizacion.valor3 &&
      Number(valorizacion.valor3 > 0) &&
      (!valorizacion.km3 ||
        valorizacion.km3 === null ||
        Number(valorizacion.km3) <= 0)
    ) {
      mensajeAlerta(
        "Valorización de Móviles",
        "Hasta Km 3 es necesario !.",
        "error",
      );
      return;
    }

    if (
      valorizacion &&
      valorizacion.km4 &&
      Number(valorizacion.km4 > 0) &&
      Number(valorizacion.km4 <= valorizacion.km3)
    ) {
      mensajeAlerta(
        "Valorización de Móviles",
        "Km 4 debe ser mayor que km 3 !.",
        "error",
      );
      return;
    }

    if (
      valorizacion &&
      valorizacion.km4 &&
      Number(valorizacion.km4 > 0) &&
      (!valorizacion.valor4 ||
        valorizacion.valor4 === null ||
        Number(valorizacion.valor4) <= 0)
    ) {
      mensajeAlerta(
        "Valorización de Móviles",
        "Valor 4 es necesario !.",
        "error",
      );
      return;
    }

    if (
      valorizacion &&
      valorizacion.valor4 &&
      Number(valorizacion.valor4 > 0) &&
      (!valorizacion.km4 ||
        valorizacion.km4 === null ||
        Number(valorizacion.km4) <= 0)
    ) {
      mensajeAlerta(
        "Valorización de Móviles",
        "Hasta Km 4 es necesario !.",
        "error",
      );
      return;
    }

    if (
      valorizacion &&
      valorizacion.km5 &&
      Number(valorizacion.km5 > 0) &&
      Number(valorizacion.km5 <= valorizacion.km4)
    ) {
      mensajeAlerta(
        "Valorización de Móviles",
        "Km 5 debe ser mayor que km 4 !.",
        "error",
      );
      return;
    }

    if (
      valorizacion &&
      valorizacion.km5 &&
      Number(valorizacion.km5 > 0) &&
      (!valorizacion.valor5 ||
        valorizacion.valor5 === null ||
        Number(valorizacion.valor5) <= 0)
    ) {
      mensajeAlerta(
        "Valorización de Móviles",
        "Valor 5 es necesario !.",
        "error",
      );
      return;
    }

    if (
      valorizacion &&
      valorizacion.valor5 &&
      Number(valorizacion.valor5 > 0) &&
      (!valorizacion.km5 ||
        valorizacion.km5 === null ||
        Number(valorizacion.km5) <= 0)
    ) {
      mensajeAlerta(
        "Valorización de Móviles",
        "Hasta Km 5 es necesario !.",
        "error",
      );
      return;
    }

    // Llamar al context
    if (selectedRow) {
      actualizarValorizacionesMoviles({ valorizacion });
    } else {
      agregarValorizacionesMoviles({ valorizacion });
    }
    onHide();
    setSelectedRow(null);
    setTimeout(() => {
      obtenerValorizacionesMoviles();
    }, 2000);
    //exitClick();
  };

  const accesoDenegado = () => {
    mensajeAlerta(
      "Accesos",
      "No tiene permiso para acceder a esta pantalla !.",
      "error",
    );
    exitClick();
    return;
  };

  const eliminarClick = (e) => {
    if (selectedRow) {
      confirmDialog({
        message: selectedRow.id_tipomovil
          ? `Confirma eliminar el color ${selectedRow.color} - ${selectedRow.tipoMovil} ? `
          : `Confirma eliminar el color ${selectedRow.color} ? `,
        header: "Confirmación",
        icon: "pi pi-exclamation-triangle",
        acceptLabel: "Si",
        accept: () => acceptFuncEliminar(),
      });
    } else {
      toast.current.show({
        severity: "info",
        summary: "Eliminar",
        detail: "Debe seleccionar una valorización.",
        life: 3000,
      });
    }
  };

  const acceptFuncEliminar = () => {
    eliminarValorizacionesMoviles({ id: selectedRow.id });

    onHide();
    setSelectedRow(null);
    setTimeout(() => {
      obtenerValorizacionesMoviles();
    }, 2000);
  };

  const editClick = (e) => {
    if (selectedRow) {
      guardarValorizacion(selectedRow);
      setVisible(true);
    } else {
      toast.current.show({
        severity: "info",
        summary: "Editar",
        detail: "Debe seleccionar una valorización.",
        life: 3000,
      });
    }
  };

  const onHide = (e) => {
    setVisible(false);
  };

  const renderHeader = () => {
    return (
      <div>
        <Tag value="Valorización de Móviles"></Tag>
      </div>
    );
  };

  const renderFooter = () => {
    return (
      <div>
        <ButtonMui
          onClick={aceptarClick}
          color="primary"
          type="button"
          fullWidth
          variant="contained"
          startIcon={<CheckIcon />}
        >
          Aceptar
        </ButtonMui>
        <ButtonMui
          onClick={onHide}
          color="secondary"
          type="button"
          fullWidth
          variant="contained"
          startIcon={<CloseIcon />}
          autoFocus
        >
          Cancelar
        </ButtonMui>
      </div>
    );
  };

  //console.log(valorizaciones);
  //console.log(valorizacion);

  return (
    <Fragment>
      <Barra />
      <Toast ref={toast} />
      <ConfirmDialog />
      {statusAcceso === 0 || statusAcceso === 400 ? <Spinner /> : null}
      {statusAcceso === 200 ? <Fragment></Fragment> : null}
      <Fragment>
        {valorizaciones ? (
          <ThemeProvider theme={theme}>
            <Box sx={{ px: { xs: 1, sm: 2 }, pb: 3 }}>
              <PantallaHeader
                icono={<PaymentsOutlinedIcon />}
                titulo="Valores Servicios por Móvil"
                count={valorizaciones ? valorizaciones.length : null}
                onBuscar={(v) => setGlobalFilter(v)}
                acciones={[
                  {
                    label: "Nuevo",
                    variant: "contained",
                    icon: <AddIcon />,
                    onClick: addClick,
                  },
                  {
                    label: "Editar",
                    icon: <EditIcon />,
                    disabled: !selectedRow,
                    onClick: editClick,
                  },
                  {
                    label: "Eliminar",
                    color: "error",
                    icon: <DeleteOutlineIcon />,
                    disabled: !selectedRow,
                    onClick: eliminarClick,
                  },
                  {
                    label: "Cerrar",
                    variant: "text",
                    color: "inherit",
                    icon: <CloseIcon />,
                    onClick: exitClick,
                  },
                ]}
              />
              <Paper
                elevation={0}
                sx={{
                  borderRadius: 2,
                  overflow: "hidden",
                  "& .p-datatable-wrapper": { overflowX: "auto" },
                }}
              >
                  <DataTable
                    value={valorizaciones}
                    selection={selectedRow}
                    onSelectionChange={(e) => setSelectedRow(e.value)}
                    selectionMode="single"
                    dataKey="id"
                    className="p-datatable-sm p-datatable-striped p-datatable-responsive-demo mito-grid"
                    style={{ fontSize: "small" }}
                    globalFilter={globalFilter}
                    emptyMessage="No hay datos."
                    paginator
                    paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
                    currentPageReportTemplate="Mostrando {first} a {last} de {totalRecords}"
                    rows={10}
                    rowsPerPageOptions={[10, 20, 50]}
                    //paginatorLeft={paginatorLeft}
                    //paginatorRight={paginatorRight}
                  >
                    <Column
                      field="id"
                      header="ID"
                      //body={idTemplate}
                      style={{ display: "none" }}
                    ></Column>
                    <Column
                      field="color"
                      header="Color"
                      //body={nombreTemplate}
                    ></Column>
                    <Column
                      field="tipoMovil"
                      header="Tipo Móvil"
                      //body={nombreTemplate}
                    ></Column>
                    <Column
                      field="localidad"
                      header="Localidad"
                      //body={nombreTemplate}
                    ></Column>
                    <Column
                      field="km1"
                      header="Hasta Km"
                      //body={domicilioTemplate}
                    ></Column>
                    <Column
                      field="valor1"
                      header="Valor"
                      //body={telefonoTemplate}
                    ></Column>
                    <Column
                      field="km2"
                      header="Hasta Km"
                      //body={habilitadoTemplate}
                    ></Column>
                    <Column
                      field="valor2"
                      header="Valor"
                      //body={telefonoTemplate}
                    ></Column>
                    <Column
                      field="km3"
                      header="Hasta Km"
                      //body={habilitadoTemplate}
                    ></Column>
                    <Column
                      field="valor3"
                      header="Valor"
                      //body={telefonoTemplate}
                    ></Column>
                    <Column
                      field="km4"
                      header="Hasta Km"
                      //body={habilitadoTemplate}
                    ></Column>
                    <Column
                      field="valor4"
                      header="Valor"
                      //body={telefonoTemplate}
                    ></Column>
                    <Column
                      field="km5"
                      header="Hasta Km"
                      //body={habilitadoTemplate}
                    ></Column>
                    <Column
                      field="valor5"
                      header="Valor"
                      //body={telefonoTemplate}
                    ></Column>
                  </DataTable>
              </Paper>
            <Dialog
              header={renderHeader()}
              className="cierre-dialog"
              visible={visible}
              closable={false}
              footer={renderFooter()}
              breakpoints={{ "960px": "75vw" }}
              style={{ width: "50vw", paddingBottom: "0" }}
              position="center"
            >
              <Grid container spacing={3} style={{ marginTop: "1vw" }}>
                <Grid item xs={12} md={2.5} style={{ paddingLeft: 0 }}>
                  <Autocomplete
                    id="colores"
                    fullWidth
                    options={colores}
                    defaultValue={
                      selectedRow && selectedRow.color !== undefined
                        ? colores[
                            colores.findIndex(
                              (tipo) => tipo.nombre === selectedRow.color,
                            )
                          ]
                        : null
                    }
                    disableCloseOnSelect
                    noOptionsText={"No hay opciones"}
                    style={{ marginLeft: "1vw" }}
                    disablePortal
                    getOptionLabel={(option) => option.nombre}
                    renderOption={(props, option, { selected }) => {
                      const { key, ...optionProps } = props;
                      return (
                        <li key={key} {...optionProps}>
                          {option.nombre}
                        </li>
                      );
                    }}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        label="Colores"
                        variant="outlined"
                      />
                    )}
                    //onKeyDown={handleEnter}
                    disabled={selectedRow}
                    onChange={(event, value) => {
                      if (value) {
                        guardarValorizacion({
                          ...valorizacion,
                          id_color: value.id,
                          color: value.nombre,
                        });
                      } else {
                        guardarValorizacion({
                          ...valorizacion,
                          id_color: null,
                          color: null,
                        });
                      }
                      if (
                        acTipoMovil.current.getElementsByClassName(
                          "MuiAutocomplete-clearIndicator",
                        )[0]
                      ) {
                        acTipoMovil.current
                          .getElementsByClassName(
                            "MuiAutocomplete-clearIndicator",
                          )[0]
                          .click();
                      }
                      if (
                        acLocalidad.current.getElementsByClassName(
                          "MuiAutocomplete-clearIndicator",
                        )[0]
                      ) {
                        acLocalidad.current
                          .getElementsByClassName(
                            "MuiAutocomplete-clearIndicator",
                          )[0]
                          .click();
                      }
                    }}
                  />
                </Grid>

                <Grid item xs={12} md={6} style={{ marginLeft: "1em" }}>
                  <Autocomplete
                    id="tiposMoviles"
                    ref={acTipoMovil}
                    fullWidth
                    disablePortal
                    required
                    options={tiposMoviles}
                    //inputValue={tiposMoviles[1].nombre}

                    defaultValue={
                      selectedRow && selectedRow.id_tipomovil !== undefined
                        ? tiposMoviles[
                            tiposMoviles.findIndex(
                              (tipo) => tipo.id === selectedRow.id_tipomovil,
                            )
                          ]
                        : null
                    }
                    //defaultValue={tiposMoviles[1]}
                    getOptionLabel={(option) => option.nombre}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        label="Tipo de móvil"
                        variant="outlined"
                      />
                    )}
                    //onKeyDown={handleEnter}
                    disabled={
                      (valorizacion && valorizacion.color !== "AZUL") ||
                      selectedRow
                    }
                    onChange={(event, value) => {
                      if (value) {
                        guardarValorizacion({
                          ...valorizacion,
                          id_tipomovil: value.id,
                          movil: value.nombre,
                        });
                      } else {
                        guardarValorizacion({
                          ...valorizacion,
                          id_tipomovil: null,
                          movil: null,
                        });
                      }
                    }}
                  />
                </Grid>


                <Grid item xs={12} md={2.5} style={{ paddingLeft: 0 }}>
                  <Autocomplete
                    id="localidades"
                    ref={acLocalidad}
                    fullWidth
                    options={localidades}
                    defaultValue={
                      selectedRow && selectedRow.localidad !== undefined
                        ? localidades[
                            localidades.findIndex(
                              (tipo) => tipo.nombre === selectedRow.localidad,
                            )
                          ]
                        : null
                    }
                    disableCloseOnSelect
                    noOptionsText={"No hay opciones"}
                    style={{ marginLeft: "1vw" }}
                    disablePortal
                    getOptionLabel={(option) => option.nombre}
                    renderOption={(props, option, { selected }) => {
                      const { key, ...optionProps } = props;
                      return (
                        <li key={key} {...optionProps}>
                          {option.nombre}
                        </li>
                      );
                    }}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        label="Localidades"
                        variant="outlined"
                      />
                    )}
                    //onKeyDown={handleEnter}
                    disabled={selectedRow}
                    onChange={(event, value) => {
                      if (value) {
                        guardarValorizacion({
                          ...valorizacion,
                          id_localidad: value.id,
                          localidad: value.nombre,
                        });
                      } else {
                        guardarValorizacion({
                          ...valorizacion,
                          id_localidad: null,
                          localidad: null,
                        });
                      }
                    }}
                  />
                </Grid>



                <Grid item xs={12} md={2}>
                  <TextField
                    id="km1"
                    label="1-Hasta KM"
                    type="number"
                    fullWidth
                    value={valorizacion ? valorizacion.km1 : null}
                    variant="outlined"
                    //onKeyDown={handleEnter}
                    InputLabelProps={{
                      shrink: true,
                    }}
                    onChange={(e) =>
                      guardarValorizacion({
                        ...valorizacion,
                        km1: e.target.value,
                      })
                    }
                  />
                </Grid>

                <Grid item xs={12} md={6} style={{ marginLeft: "2vw" }}>
                  <label htmlFor="valor1">Valor</label>
                  <InputNumber
                    id="valor1"
                    inputId="valor1"
                    value={valorizacion ? valorizacion.valor1 : null}
                    onChange={(e) =>
                      guardarValorizacion({
                        ...valorizacion,
                        valor1: e.value,
                      })
                    }
                    mode="decimal"
                    locale="en-US"
                    minFractionDigits={2}
                    style={{ marginLeft: "0.7vw", marginTop: "0.6vw" }}
                  />
                </Grid>

                <Grid item xs={12} md={2} />

                <Grid item xs={12} md={2}>
                  <TextField
                    id="km2"
                    label="2-Hasta KM"
                    type="number"
                    fullWidth
                    value={valorizacion ? valorizacion.km2 : null}
                    variant="outlined"
                    //onKeyDown={handleEnter}
                    InputLabelProps={{
                      shrink: true,
                    }}
                    onChange={(e) =>
                      guardarValorizacion({
                        ...valorizacion,
                        km2: e.target.value,
                      })
                    }
                    disabled={
                      valorizacion &&
                      (!valorizacion.km1 ||
                        valorizacion.km1 === null ||
                        Number(valorizacion.km1) <= 0)
                    }
                  />
                </Grid>

                <Grid item xs={12} md={6} style={{ marginLeft: "2vw" }}>
                  <label htmlFor="valor2">Valor</label>
                  <InputNumber
                    id="valor2"
                    inputId="valor2"
                    value={valorizacion ? valorizacion.valor2 : null}
                    onChange={(e) =>
                      guardarValorizacion({
                        ...valorizacion,
                        valor2: e.value,
                      })
                    }
                    disabled={
                      valorizacion &&
                      (!valorizacion.valor1 ||
                        valorizacion.valor1 === null ||
                        Number(valorizacion.valor1) <= 0)
                    }
                    mode="decimal"
                    locale="en-US"
                    minFractionDigits={2}
                    style={{ marginLeft: "0.7vw", marginTop: "0.6vw" }}
                  />
                </Grid>

                <Grid item xs={12} md={2} />

                <Grid item xs={12} md={2}>
                  <TextField
                    id="km3"
                    label="3-Hasta KM"
                    type="number"
                    fullWidth
                    value={valorizacion ? valorizacion.km3 : null}
                    variant="outlined"
                    //onKeyDown={handleEnter}
                    InputLabelProps={{
                      shrink: true,
                    }}
                    onChange={(e) =>
                      guardarValorizacion({
                        ...valorizacion,
                        km3: e.target.value,
                      })
                    }
                    disabled={
                      valorizacion &&
                      (!valorizacion.km2 ||
                        valorizacion.km2 === null ||
                        Number(valorizacion.km2) <= 0)
                    }
                  />
                </Grid>

                <Grid item xs={12} md={6} style={{ marginLeft: "2vw" }}>
                  <label htmlFor="valor3">Valor</label>
                  <InputNumber
                    id="valor3"
                    inputId="valor3"
                    value={valorizacion ? valorizacion.valor3 : null}
                    onChange={(e) =>
                      guardarValorizacion({
                        ...valorizacion,
                        valor3: e.value,
                      })
                    }
                    disabled={
                      valorizacion &&
                      (!valorizacion.valor2 ||
                        valorizacion.valor2 === null ||
                        Number(valorizacion.valor2) <= 0)
                    }
                    mode="decimal"
                    locale="en-US"
                    minFractionDigits={2}
                    style={{ marginLeft: "0.7vw", marginTop: "0.6vw" }}
                  />
                </Grid>

                <Grid item xs={12} md={2} />

                <Grid item xs={12} md={2}>
                  <TextField
                    id="km4"
                    label="4-Hasta KM"
                    type="number"
                    fullWidth
                    value={valorizacion ? valorizacion.km4 : null}
                    variant="outlined"
                    //onKeyDown={handleEnter}
                    InputLabelProps={{
                      shrink: true,
                    }}
                    onChange={(e) =>
                      guardarValorizacion({
                        ...valorizacion,
                        km4: e.target.value,
                      })
                    }
                    disabled={
                      valorizacion &&
                      (!valorizacion.km3 ||
                        valorizacion.km3 === null ||
                        Number(valorizacion.km3) <= 0)
                    }
                  />
                </Grid>

                <Grid item xs={12} md={6} style={{ marginLeft: "2vw" }}>
                  <label htmlFor="valor4">Valor</label>
                  <InputNumber
                    id="valor4"
                    inputId="valor4"
                    value={valorizacion ? valorizacion.valor4 : null}
                    onChange={(e) =>
                      guardarValorizacion({
                        ...valorizacion,
                        valor4: e.value,
                      })
                    }
                    disabled={
                      valorizacion &&
                      (!valorizacion.valor3 ||
                        valorizacion.valor3 === null ||
                        Number(valorizacion.valor3) <= 0)
                    }
                    mode="decimal"
                    locale="en-US"
                    minFractionDigits={2}
                    style={{ marginLeft: "0.7vw", marginTop: "0.6vw" }}
                  />
                </Grid>

                <Grid item xs={12} md={2} />

                <Grid item xs={12} md={2}>
                  <TextField
                    id="km5"
                    label="5-Hasta KM"
                    type="number"
                    fullWidth
                    value={valorizacion ? valorizacion.km5 : null}
                    variant="outlined"
                    //onKeyDown={handleEnter}
                    InputLabelProps={{
                      shrink: true,
                    }}
                    onChange={(e) =>
                      guardarValorizacion({
                        ...valorizacion,
                        km5: e.target.value,
                      })
                    }
                    disabled={
                      valorizacion &&
                      (!valorizacion.km4 ||
                        valorizacion.km4 === null ||
                        Number(valorizacion.km4) <= 0)
                    }
                  />
                </Grid>

                <Grid item xs={12} md={6} style={{ marginLeft: "2vw" }}>
                  <label htmlFor="valor5">Valor</label>
                  <InputNumber
                    id="valor5"
                    inputId="valor5"
                    value={valorizacion ? valorizacion.valor5 : null}
                    onChange={(e) =>
                      guardarValorizacion({
                        ...valorizacion,
                        valor5: e.value,
                      })
                    }
                    disabled={
                      valorizacion &&
                      (!valorizacion.valor4 ||
                        valorizacion.valor4 === null ||
                        Number(valorizacion.valor4) <= 0)
                    }
                    mode="decimal"
                    locale="en-US"
                    minFractionDigits={2}
                    style={{ marginLeft: "0.7vw", marginTop: "0.6vw" }}
                  />
                </Grid>
              </Grid>
            </Dialog>
            </Box>
          </ThemeProvider>
        ) : (
          <Spinner />
        )}
        <Grid item xs={12} sm={12}></Grid>
      </Fragment>
    </Fragment>
  );
}

/* class="MuiDataGrid-cell MuiDataGrid-cellLeft" */
